import React, { useState, useRef, useEffect } from "react";
import { kbdEvent } from "../utils/Utils";
import { KBD } from "../utils/Keybindings";
import Float from "./Float";

const SelectBox = React.forwardRef((props, ref) => {
    const {
        width = 100,
        value = null,
        options = [],
        className = "",
        style = {},
        edit = false,
        placeholder = "",
        onChange = () => { },
        onEnter = null,
        onPageUp = null,
        onPageDown = null,
        onFocus = () => { },
        onBlur = () => { },
        render = false,
        autofocus = false,
        dataId = "",
        opened = false,
        allowKeys = false,
        keyfield = "key"
    } = props;

    console.log(options)

    const [isOpen, setIsOpen] = useState(opened);
    const [isFocused, setIsFocused] = useState(false);

    const [highlightIndex, setHighlightIndex] = useState(() => {
        const idx = options.findIndex(o => o.value === value);
        return idx >= 0 ? idx : 0;
    });


    useEffect(() => {
        const idx = options.findIndex(o => o.value === value);
        setHighlightIndex(idx >= 0 ? idx : 0);
    }, [value, options]);

    let _class = edit ? "ui-input edit" : "ui-input";
    if (className) _class += ` ${className}`;


    if (width) style.width = `${width}px`;


    const selectedOption = options.find(o => o.value === value);

    const handleSelect = (opt) => {
        onChange(opt.value);
        setTimeout(() => {
            setIsOpen(false);
        }, 10)

    };

    useEffect(() => {
        if (isFocused) {
            setIsOpen(true)
        }
    }, [isFocused])

    const handleKeyDown = (e) => {


        if (allowKeys && isOpen) {
            if (/^[a-zA-Z]$/.test(e.key)) {

                const _f = options.find(item => item[keyfield].toLowerCase() === e.key.toLowerCase());
                if (_f) {
                    e.preventDefault();
                    e.stopPropagation();
                    handleSelect(_f);
                    if (onEnter) onEnter(value, e);
                }
            }
        }

        if (e.key === "ArrowDown" && isOpen) {
            e.stopPropagation();
            e.preventDefault();

            if ((highlightIndex + 1) > (options.length - 1)) {
                kbdEvent(KBD.TAB);
            } else {
                setHighlightIndex(i => i + 1);
            }


            return;
        }

        if (e.key === "ArrowUp" && isOpen) {
            e.stopPropagation();
            e.preventDefault();
            if ((highlightIndex - 1) < 0) {
                kbdEvent(KBD.SHIFT_TAB);
            } else {
                setHighlightIndex(i => i - 1);
            }

            return;
        }


        if (e.key === "Enter") {
            const opt = options[highlightIndex];
            if (isOpen) {
                handleSelect(opt);
                return;
            }

            if (opt) handleSelect(opt);
            if (onEnter) onEnter(value, e);
            setIsOpen(false);
            return;
        }

        if (e.key === "PageUp" && onPageUp) {
            onPageUp(value);
        }

        if (e.key === "PageDown" && onPageDown) {
            onPageDown(value, e);
        }
    };

    const handleFocus = () => {
        setIsFocused(true);
        setIsOpen(true);
        onFocus();
    };

    const handleBlur = () => {
        setIsFocused(false);
        setTimeout(() => setIsOpen(false), 100);
        onBlur(value);
    };

    if (edit) {
        return (
            <div
                data-id={dataId}
                className={_class}
                style={style}
                tabIndex={0}
                ref={ref}
                onKeyDown={handleKeyDown}
                onFocus={handleFocus}
                onBlur={handleBlur}
                onClick={() => {
                    setIsOpen(o => !o)
                }}
            >

                <div style={{ "opacity": (selectedOption?.label) ? "1" : "0.6", userSelect: "none" }} className="ui-select-display">
                    {selectedOption?.label || placeholder}&nbsp;
                </div>

                {isOpen && isFocused && (
                    <div style={{ "width": width + 12 + "px" }} className="ui-select-dropdown">
                        {options.map(opt => (
                            <div
                                key={opt.value}
                                style={{ "color": (opt?.color) ? opt.color : "inherit" }}
                                className={`ui-select-option ${options[highlightIndex]?.value === opt.value ? "active" : ""}`}
                                onMouseDown={(e) => e.preventDefault()}
                                onClick={() => handleSelect(opt)}
                            >
                                <Float style={{ "alignContent": "center" }}>
                                    <span style={{ "pointerEvents": "none" }}>{opt.label}</span>
                                    <div style={{ "textAlign": "right", "fontSize": "12px" }}>
                                        {(allowKeys && <kbd className="small" style={{ "opacity": "0.7", "fontWeight": "600" }}>&nbsp;{opt.value}&nbsp;</kbd>)}
                                    </div>
                                </Float>

                            </div>
                        ))}
                    </div>
                )}
            </div>
        );
    }

    return (
        <div
            data-id={dataId}
            className={_class}
            style={style}
        >
            {render !== false
                ? render
                : selectedOption?.label || (
                    <em style={{ opacity: 0.5 }}>{placeholder}</em>
                )
            }
        </div>
    );
});

export default SelectBox;